import React from 'react';
import { Helmet } from 'react-helmet-async';

const FullWidthPageWrapper = ({ title, children }) => (
  <>
    <Helmet>
      <title>{title}</title>
    </Helmet>
    <div style={{
      height: '100%',
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      overflow: 'hidden',
      padding: '12px',
    }}>
      <div style={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: '#FFF',
        borderRadius: '6px',
        boxShadow: 'rgba(50, 50, 93, 0.025) 0px 2px 5px -1px, rgba(0, 0, 0, 0.05) 0px 1px 3px -1px',
        overflow: 'hidden',
      }}>
        {children}
      </div>
    </div>
  </>
);

export default FullWidthPageWrapper;
